import Lookup from 'src/componentes/select2';

const StatusGeralDocumentoLookup = ({ ...rest }) => (
  <Lookup
    labelKey="nome"
    valueKey="id"
    url="/StatusGeralDocumentoLookup"
    clearable
    {...rest}
  />
);

export default StatusGeralDocumentoLookup;
